import styled from 'styled-components';

export const StaffPageHeaderHolder = styled.div`
  font-size: 12px;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 101;
`;
